<template lang="pug">
form(@submit.prevent="navigate('sistema.docModelos.new.textos')")
  p.text-large - Integração
  .columns
    .column.col-6.col-md-8.col-12
      .columns
        .column.col-12
          form-group(
            label="Atualizar Cadastro no Tributário?",
            :validation="$v.resource.params.osm.altera_situacao_mobiliario"
          )
            select.form-select(
              v-model="$v.resource.params.osm.altera_situacao_mobiliario.$model"
            )
              option(:value="0") Não atualizar
              option(value="normal") Normal
              option(value="nao_emite_iss_emite_taxa") Não emite iss emite taxa
              option(value="nao_emite_iss_nao_emite_taxa") Não emite iss não emite taxa
              option(value="emite_iss_nao_emite_taxa_mei") Emite iss não emite taxa mei
              option(value="normal_isento_licenca_sanitaria") Normal isento licença sanitária
              option(value="alvara_cassado") Alvará cassado
              option(value="desatualizado") Desatualizado
              option(value="vencido") Vencido
              option(value="empresa_estabelecida_fora") Empresa estabelecida fora
              option(value="baixado") Baixado
              option(value="alvara_anulado") Alvará anulado
              option(value="obra_concluida") Obra concluída
              option(value="embargado") Embargado
              option(value="interditado") Interditado
              option(value="invalido_excluido") Inválido excluído
            .form-input-hint Situação para atualizar o tributário no momento da ciência
  .pt-2
    .divider
    button.btn.btn-primary(:disabled="$v.resource.$invalid")
      btn-content(name="next")
</template>

<script>
import createMixin from "./mixin"

export default {
  mixins: [createMixin],
  validations: {
    resource: {
      params: {
        osm: {
          altera_situacao_mobiliario: {},
        },
      },
    },
  },
}
</script>
